import React from 'react';
import { InputNumber as AntdInputNumber } from 'antd';
import type { InputNumberProps as AntdInputNumberProps } from 'antd';

export type InputNumberProps = AntdInputNumberProps;

/**
 * InputNumber component - numeric input field with increment and decrement controls
 */
const InputNumber: React.FC<InputNumberProps> = (props) => {
  return <AntdInputNumber {...props} />;
};

export default InputNumber;
